module.exports = __webpack_public_path__ + "static/logistics-tracking@3x-d292549a3e9f2a10dc460b27b7228e06.png";